import type { ReactNode } from "react";
import Tooltip from "ui/popovers/Tooltip";
import styles from "./PlanLibraryOptionValue.module.scss";

interface PlanLibraryOptionValueProps {
  field: string;
  children: ReactNode;
  isOverridden: boolean;
  inheritedValue: any;
}

export function PlanLibraryOptionValue({ field, children, isOverridden, inheritedValue }: PlanLibraryOptionValueProps) {
  if (isOverridden) {
    return (
      <Tooltip.Root delayDuration={0}>
        <Tooltip.Trigger>
          <div className={styles.overwrittenOptionSetValueWrapper}>{children}</div>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <span>
            Inherited Value: <br />
            <b>{inheritedValue || `No ${field}`}</b>
          </span>
        </Tooltip.Content>
      </Tooltip.Root>
    );
  }

  return <>{children}</>;
}
